// extracted by mini-css-extract-plugin
export var boldText = "_7x-4";
export var checkboxContainer = "_7x-6";
export var closeIcon = "_7x-i";
export var container = "_7x-0";
export var drawer = "_7x-8";
export var drawerContent = "_7x-9";
export var extraSmallText = "_7x-5";
export var fulfillmentGroupTable = "_7x-e";
export var largeText = "_7x-3";
export var loadingSpinnerContainer = "_7x-j";
export var mediumText = "_7x-2";
export var narrow = "_7x-f";
export var notificationLink = "_7x-l";
export var packageCheckIconContainer = "_7x-7";
export var slideoutHeaderActions = "_7x-g";
export var slideoutHeaderActionsShifted = "_7x-h";
export var slideoutHeaderContainer = "_7x-a";
export var slideoutModal = "_7x-c";
export var stickyHeaderWrapper = "_7x-b";
export var table = "_7x-k";
export var tableContainer = "_7x-d";
export var tertiaryText = "_7x-1";